module.exports = "<h1 class=\"md-display-1\">\r\n    {{$ctrl.labelKey | translate}}\r\n    <md-button ng-repeat=\"command in $ctrl.commands track by $index\" ng-click=\"$ctrl.doCommand(command)\"\r\n        aria-label=\"{{command.title | translate}}\" class=\"md-raised md-primary\" permission-only=\"{{command.only}}\"\r\n        ng-disabled=\"{{command.disabled}}\">\r\n        <md-icon md-svg-icon=\"{{command.iconUrl}}\" class=\"gmao-command-icon\"></md-icon>{{command.title | translate}}\r\n    </md-button>\r\n</h1>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/main/front/scripts/module/util/component/gmao-view-header.html
// module id = 303
// module chunks = 1